import Image from 'next/image';
import React from 'react';

interface CountryFlagProps {
  country: string;
  alt: string;
  className?: string;
}

/**
 * The 18x13 box a flag sits in comes from the caller's Tailwind classes — that is, from the
 * stylesheet. `fill` was the wrong tool for that: next/image implements it as inline
 * `position:absolute; width:100%; height:100%` on the <img>, and inline styles apply even when the
 * stylesheet does not. With no CSS (a cached HTML pointing at a CSS hash a deploy removed, a
 * blocked or dropped request) the 100% resolved against the viewport and the flag covered the whole
 * screen — reproduced at 1280x720 on /pt/affiliates.
 *
 * Intrinsic width/height land as HTML attributes instead, which the browser honours before any CSS
 * arrives and without any CSS at all, so the worst case is a correctly sized flag. The declared box
 * is the design's 18x13 rather than each file's own size (they range from 19x13 to 24x24), with
 * object-fit cropping to it — same framing the previous `object-cover` produced, minus the
 * dependency on CSS being there.
 */
const FLAG_WIDTH = 18;
const FLAG_HEIGHT = 13;

const CountryFlag = ({ country, alt, className }: CountryFlagProps) => {
  return <Image src={`/assets/images/countries/${country}.svg`} alt={alt} width={FLAG_WIDTH} height={FLAG_HEIGHT} className={className} style={{ objectFit: 'cover' }} />;
};

export default CountryFlag;
